import { Component, EventEmitter, Output } from '@angular/core';
import { ProgressBarComponent } from '../progress-bar/progress-bar.component';
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { BiqButtonComponent } from '../biq-button/biq-button.component';
import { UserBiqData } from '@app/schemas/biq';
import { Store } from '@ngrx/store';
import { updateUserBiq } from '@app/state/actions/biq.action';
import { BIQ_TOTAL_QUESTIONS } from '@app/utils/constants';

@Component({
  selector: 'app-biq-fullname',
  imports: [
    ProgressBarComponent,
    FormsModule, 
    MatFormFieldModule, 
    MatInputModule, 
    ReactiveFormsModule,
    BiqButtonComponent,
  ],
  templateUrl: './fullname.component.html',
  styleUrl: './fullname.component.css'
})
export class FullnameComponent {
  @Output() continueEmitter: EventEmitter<void> = new EventEmitter<void>();
  public questNo: number = 0;
  public totalQuestions: number = BIQ_TOTAL_QUESTIONS;
  public firstnameControl = new FormControl('', [Validators.required, Validators.pattern(/\S/)]);
  public lastnameControl = new FormControl('', [Validators.required, Validators.pattern(/\S/)]);
  public storedBiqData!: UserBiqData;

  constructor(private store: Store<{ userBiq: UserBiqData }>) {
    this.store.select('userBiq').subscribe(value => {
      this.storedBiqData = value;
      if (value && value.firstName) {
        this.firstnameControl.setValue(value.firstName);
        this.lastnameControl.setValue(value.lastName);
      }
    });
  }

  onClickContinue() {
    this.firstnameControl.markAsTouched();
    this.lastnameControl.markAsTouched();
    if (this.firstnameControl.invalid || this.lastnameControl.invalid) return;

    const updatedBiq = {
      ...this.storedBiqData,
      firstName: this.firstnameControl.value!.trim(),
      lastName: this.lastnameControl.value!.trim(),
    }
    this.store.dispatch(updateUserBiq({ user: updatedBiq }));
    this.continueEmitter.emit();
  }
}
